import React, { useState, useEffect, useRef } from 'react'
import emailjs from 'emailjs-com'
import { FaLinkedin, FaGithub, FaFacebook, FaYoutube } from 'react-icons/fa'

const Links = ({ setShowFaces }) => {
  const [messageForm, setMessageForm] = useState(null)
  const form = useRef(null)
  const serviceId = process.env.REACT_APP_SERVICE_ID
  const templateId = process.env.REACT_APP_TEMPLATE_ID
  const publicId = process.env.REACT_APP_PUBLIC_ID
  const theName = process.env.REACT_APP_NAME

  const onInput = e => {
    setMessageForm({
      ...messageForm,
      ...{ [e.target.previousElementSibling.innerText]: e.target.value },
    })
  }

  // @desc send me an email
  const sendEmail = e => {
    e.preventDefault()
    try {
      if (!messageForm?.Name && !messageForm?.Email && !messageForm?.Message) {
        alert('Please fill the form first!')
        if (messageForm?.Email) {
          function validateEmail(email) {
            const regexp =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!regexp.test(email)) {
              alert('Invalid Email')
            }
          }
        }
      } else {
        emailjs.sendForm(serviceId, templateId, form.current, publicId).then(
          result => {
            console.log(result.text)
          },
          error => {
            console.log(error.text)
          }
        )
        alert('Email sent successfully')
        window.location.reload()
      }
    } catch (error) {
      console.error(error.message)
    }
  }

  useEffect(() => {
    setShowFaces(true)
    setTimeout(() => {
      setShowFaces(false)
    }, 4000)
  }, [])

  return (
    <div className='links'>
      <h2>Send me an Email!</h2>
      <form ref={form} action='submit' onSubmit={sendEmail}>
        <label>Name</label>
        <input
          autoFocus
          name='name'
          placeholder='Your Name...'
          required
          onInput={onInput}
          type='text'
          maxLength={15}
        />
        <label>Email</label>
        <input
          name='email'
          placeholder='Your Email...'
          required
          type='email'
          onInput={onInput}
        />
        <label>Message</label>
        <textarea
          name='message'
          required
          placeholder='Your Message...'
          columns={6}
          rows={5}
          onInput={onInput}
          maxLength={500}
        />
        <button className='form-submit-btn'>Submit</button>
      </form>

      <nav className='nav-links'>
        <a
          target='#'
          href='https://www.youtube.com/channel/UCGnwxfLJ-78-UBfmZ-suakQ'
        >
          <FaYoutube />
        </a>
        <a target='#' href='https://github.com/BasharAlwarad'>
          <FaGithub />
        </a>
        <a target='#' href='https://www.facebook.com/'>
          <FaFacebook />
        </a>
        <a
          target='#'
          href='https://www.linkedin.com/in/bashar-alwarad-2a960b1b6/'
        >
          <FaLinkedin />
        </a>
      </nav>
      <a
        target='#'
        href={require('../bdfs/Resume-Bashar-Alwarad.pdf')}
        download='Bashar_Alwarad_Resume.pdf'
      >
        <button className='resume'>Resume</button>
      </a>
    </div>
  )
}

export default Links
